import { FC, Fragment, useEffect, useState } from 'react';
import ProductHeader from '../ProductHeader';
import CommonCardA from '../CommonCardA';
import ViewMore from '../ViewMore';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps, ProductModule } from '@/components/MembersDay/type';

const Accessories: FC<IProductProps> = ({ module, icon, title, desc, id = 'activity-Accessories', isNeedBtn }) => {
    const { locale } = getLocal();
    const { t } = useLang(`membersday.return`);
    const { productList } = useProductList(module, locale);
    const [isPC, setIsPC] = useState(true);
    const [isCenter, setIsCenter] = useState(false);

    // au ACCESSORY模块特殊处理
    const isPassLogin = locale === 'au' && module === ProductModule.ACCESSORY;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    useEffect(() => {
        const len = productList?.length || 0;
        setIsCenter(isPC ? len < 4 : len < 2);
    }, [isPC, productList]);

    return (
        <div className={`${styled.content}`} id={id}>
            <ProductHeader icon={icon} title={title} desc={desc} showUseCode={isPassLogin} />
            <div className={`members-day-inter ${isCenter ? 'center' : 'left'}`}>
                {productList.map((item) => {
                    return (
                        <Fragment key={item.variantId}>
                            <CommonCardA data={item} list_name={title} passLogin={isPassLogin} />
                        </Fragment>
                    );
                })}
            </div>
            {isNeedBtn && <ViewMore href={`https://${locale}.ecoflow.com/pages/refurbished`} viewBtnText={`${t('shop_the_entire_sale')}`} />}
        </div>
    );
};

export default Accessories;
